import { render, staticRenderFns } from "./CCHeader.vue?vue&type=template&id=9387fb3a&scoped=true"
import script from "./CCHeader.vue?vue&type=script&lang=js"
export * from "./CCHeader.vue?vue&type=script&lang=js"
import style0 from "./CCHeader.vue?vue&type=style&index=0&id=9387fb3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9387fb3a",
  null
  
)

export default component.exports